import { RESOURCE_PROCESSOR_MAP } from "@limitless/common/apis/resource-api";
import { log as pilog } from "@limitless/common/utils";
export const getCommonTransformedOptions = props => {
  const {
    applicationName = "crowd-manager",
    locale = "en-GB",
    folder = "",
    groupName = "",
    tenantName = "",
    baseLocation = "",
    fileName = ""
  } = props;
  if (props.contentEncoding && props.contentType) {
    return {
      applicationName,
      locale,
      folder,
      groupName,
      tenantName,
      baseLocation,
      fileName,
      contentType: props.contentType,
      contentEncoding: props.contentEncoding
    };
  }
  return {
    applicationName,
    locale,
    folder,
    groupName,
    tenantName,
    baseLocation,
    fileName
  };
};
export const transformSearchOptions = searchOptions => {
  const {
    processResources = RESOURCE_PROCESSOR_MAP["text"],
    shouldMergeContent = false,
    ignoreCache = false,
    replaceFieldValue = false,
    encoding = "text",
    fileName = ""
  } = searchOptions;
  const body = {
    ...getCommonTransformedOptions(searchOptions),
    resourceName: fileName,
    ignoreCache,
    replaceFieldValue,
    encoding
  };
  return {
    body,
    shouldMergeContent,
    processResources
  };
};
export const processContentAPIResponse = (response, processResources, shouldMergeContent) => {
  const log = pilog.getLogger("ContentManagerActions processContentAPIResponse");
  if (!Array.isArray(response)) {
    log.debug("Content Resource is an object ");
    const processedContent = createContentObject(processResources(response), shouldMergeContent);
    log.debug(processedContent);
    return processedContent;
  } else {
    const contentResources = [];
    response.map(platformContent => {
      const processedContent = processResources(platformContent);
      contentResources.push(createContentObject(processedContent, shouldMergeContent));
    });
    log.debug(contentResources);
    return contentResources;
  }
};
const createContentObject = (processedContent, shouldMergeContent) => {
  let content = {
    ...processedContent
  };
  if (shouldMergeContent === true) {
    content.data = processedContent.content;
  } else {
    content = {
      ...content,
      ...processedContent.content
    };
  }
  Reflect.deleteProperty(content, "content");
  return content;
};